<template>
  <div class="min-h-screen w-full bg-[#f7f7f7] flex flex-col">
    <div class="flex-1 flex flex-col relative">
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-[#f7f7f7]">
        <router-view></router-view>
      </main>
    </div>
    <Toaster />
    <OfferNegotiationCelebrationModal />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import Toaster from '@/components/ui/toast/Toaster.vue'
import OfferNegotiationCelebrationModal from '@/components/userApplications/OfferNegotiationCelebrationModal.vue'

const authStore = useAuthStore();

onMounted(async () => {
  await authStore.initAuth();
});
</script>

<style>
.p-toast .p-toast-message {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Optional: Style specific toast types */
.p-toast .p-toast-message.p-toast-message-success,
.p-toast .p-toast-message.p-toast-message-error {
  margin-top: 4rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(85, 85, 85, 0.1);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  .p-toast-message-text {
    gap: 0.1rem;
  }
  .p-toast-detail {
    font-size: 0.8rem;
  }
}

/* Add mobile viewport fixes */
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
</style>